import { PaletteMode } from '@mui/material';

export const getDesignTokens = async (mode: PaletteMode) => {
	const { default: getTokens } = await import('../../assets/theme/theme');

	return getTokens(mode);
};
